"use strict";

var SoaCollection = require('bunsen/collections/SoaCollection');
var PermissionList = module.exports = SoaCollection.extend();
var Permission = require('bunsen/models/identity/Permission');
var _ = require('underscore');

_.extend(PermissionList.prototype, {
    model: Permission,
    comparator: 'name',

    /**
     * Check permissions for a given user.
     * @param required - The required permission to complete this action.
     * @returns {*}
     */
    checkPermissions: function (required) {
        // Return true if nothing is passed in for required
        if (!required || _.isEmpty(required)) {
            return true;
        }

        // If required is a string, check if it's in the available array
        if (typeof required === 'string') {
            return !_.isUndefined(this.findWhere({name: required}));
        }
        // If required is an array, check if at least one of them is in available
        return _.some(required, function (perm) {
            return !_.isUndefined(this.findWhere({name: perm}));
        }, this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/PermissionList.js
// module id = 2029
// module chunks = 62